module.exports = __webpack_public_path__ + "img/dex_unboundtoken.2333fe4.png";